.sidebar {
  width: 220px;
  flex-shrink: 0;
  border-right: 1px solid var(--ps-border-default);
  padding: 8px 0;
  position: sticky;
  top: 0;
  align-self: flex-start;
}

.heading {
  padding: 0 16px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ps-text-muted);
}

.item {
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  font-size: 13px;
  background: transparent;
  border: none;
  border-left: 3px solid transparent;
  color: var(--ps-text-secondary);
  cursor: pointer;
  transition: all var(--ps-duration-base) var(--ps-ease-default);
}

.item:hover {
  color: var(--ps-text-primary);
}

.itemActive,
.itemActive:hover {
  font-weight: 600;
  background: var(--ps-bg-elevated);
  color: var(--ps-gold);
  border-left-color: var(--ps-gold);
}

.label {
  flex: 1;
}

.count {
  font-size: 10px;
  color: var(--ps-text-muted);
}
